export default "__VITE_ASSET__BY2At2Yq__"